module.exports = __webpack_public_path__ + "img/activities-summer-school.9ef9bc4c.jpg";